import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { Box, createStyles, WithStyles, withStyles } from '@material-ui/core'
import { useRouter } from 'next/router'

import { LoadingOverlay } from '../../../components'
import { theme } from '../../../theme/'
import RootStore from '../../../src/stores/RootStore'
import CategoryTreatments from '../../../components/CategoryTreatments'
import { CategoryViewModel } from '../../../pagesModels/ViewCategoryViewModel'
import useViewModel from '../../../shared-lib/hooks/useViewModel'
import PageTitle from '../../../components/PageTitle'

interface Props extends WithStyles<typeof styles> {
  store: RootStore
  query: any
}

const styles = () => createStyles({
  trustPilotWrapper: {
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(4),
    },
  },
})

const CategoryScreen = (props: Props) => {
  const { store } = props
  const { treatmentStore } = store!

  const viewModel = useViewModel(CategoryViewModel, props.store!)
  const { category, treatmentsWithLiquidityData, setCategory } = viewModel
  const router = useRouter()

  useEffect(() => {
    setCategory((router.query.id as string).toLowerCase())
  }, [router.query.id, setCategory])

  if (!category) {
    return null
  }

  if (category.loading || treatmentStore.loading) {
    return <Box position='relative' height='100%'>
      <LoadingOverlay />
    </Box>
  }

  return <>
    <PageTitle title={category.data.name} />

    <div className='animate__animated animate__fadeIn'>
      <CategoryTreatments viewModel={viewModel} treatments={treatmentsWithLiquidityData} />
    </div>
  </>
}

export default withStyles(styles)(inject('store')(observer(CategoryScreen)))
